<template src="./FilterModal.html">
</template>

<script>
/* testing */
export default {
  name: "filter-modal",
  props: {
    filterList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedFilters: [],
      filterOptions: []
    };
  },
  methods: {
    showFilterOptions(options, selected = []) {
      this.filterOptions = options || this.filterList;
      this.selectedFilters = [...selected];
      this.$refs.modal.show();
    },
    applyFilters() {
      this.$emit("filters-applied", this.selectedFilters);
      this.$refs.modal.hide();
    },
    cancel() {
      this.$refs.modal.hide();
    }
  }
};
</script>
